import React, { createContext, useState, useContext, useEffect } from 'react';
import { getDepartments } from '../services/api';

// Create the context
const DepartmentContext = createContext();

// Custom hook to use the department context
export const useDepartment = () => useContext(DepartmentContext);

// Provider component
export const DepartmentProvider = ({ children }) => {
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load departments on mount
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        setLoading(true);
        const response = await getDepartments();
        setDepartments(response.data);
        
        // Check if there's a saved department in localStorage
        const savedDepartmentId = localStorage.getItem('selectedDepartmentId');
        if (savedDepartmentId) {
          const dept = response.data.find(d => d.department_id === parseInt(savedDepartmentId));
          if (dept) {
            setSelectedDepartment(dept);
          }
        }
      } catch (err) {
        console.error('Error fetching departments:', err);
        setError('Failed to load departments');
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  // Save selected department to localStorage
  useEffect(() => {
    if (selectedDepartment) {
      localStorage.setItem('selectedDepartmentId', selectedDepartment.department_id);
    }
  }, [selectedDepartment]);

  const selectDepartment = (department) => {
    setSelectedDepartment(department);
  };

  const clearDepartment = () => {
    setSelectedDepartment(null);
    localStorage.removeItem('selectedDepartmentId');
  };

  return (
    <DepartmentContext.Provider 
      value={{ 
        departments, 
        selectedDepartment, 
        selectDepartment, 
        clearDepartment,
        loading,
        error
      }}
    >
      {children}
    </DepartmentContext.Provider>
  );
};
